/* SOPI ORDER FLOW landing gallery - v0.3 (10 October 2026)
   Fix: thumbnail buttons are siblings of [data-sopi-gallery], not children.
   Event delegation also works after a Shopify Theme Editor section reload.
*/
(function () {
  'use strict';

  function showImage(button) {
    var section = button.closest('[data-sopi-landing]');
    if (!section) return;

    var gallery = section.querySelector('[data-sopi-gallery]');
    if (!gallery) return;

    var image = gallery.querySelector('.sopi-lp__hero-image');
    var link = gallery.querySelector('[data-sopi-gallery-link]');
    var src = button.getAttribute('data-src');
    if (!image || !link || !src) return;

    // image_tag includes responsive srcset/sizes. Remove them first so the
    // selected thumbnail's image is what the browser actually displays.
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = src;
    image.alt = button.getAttribute('data-alt') || 'Captura de SOPI ORDER FLOW';
    link.href = button.getAttribute('data-full') || src;

    section.querySelectorAll('[data-sopi-thumb]').forEach(function (thumb) {
      var active = thumb === button;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  // Listening at document level keeps the handler active if Shopify updates
  // the section markup in the visual editor after this script has loaded.
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;
    var button = target.closest('[data-sopi-thumb]');
    if (button) showImage(button);
  });
})();
